import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createNotification } from 'react-redux-notify';

import F2FPackageSelectionModal from '../../Modals/F2FPackageSelectionModal';
import OnScreenLoader from './OnScreenLoader';
import FacetoFacePackageService from '../../../helpers/services/f2f/package';
import F2FSendMessageToPerformer from './F2fSendMessageToPerformer';
import { SocketContext as Face2FaceSocketContext } from '../../../helpers/contexts/face2face';
import { getErrorNotificationMessage } from '../../helper/NotificationMessage';
import { parseContentServiceError } from '../../../helpers/services/f2f/error';
import { hideFace2FacePackageSelection } from '../../../store/actions/Face2FaceAction';
import { getUserId } from '../../../helpers/storage/user';

const F2FPackageSelection = () => {
  const dispatch = useDispatch();
  const Face2FaceService = useContext(Face2FaceSocketContext);

  const packageSelection = useSelector((state) => state.Package?.package_selection);
  const newSessionData = useSelector((state) => state.Session?.get_new_session?.data);

  const [packageLoader, setPackageLoader] = useState(false);
  const [packageData, setPackageData] = useState(null);
  const [packageOwner, setPackageOwner] = useState(null);
  const [isPackageSelectionModalOpen, setIsPackageSelectionModalOpen] = useState(false);
  const [showSendMessageModal, setShowSendMessageModal] = useState(false);

  useEffect(() => {
    if (
      packageSelection.show &&
      packageSelection.data?.id &&
      packageSelection.data?.id != getUserId()
    ) {
      setPackageLoader(true);
      if (!Face2FaceService.connected) {
        Face2FaceService.connect();
      }
      fetchPackages(packageSelection.data?.id, packageSelection.data?.packageId);
      dispatch(hideFace2FacePackageSelection());
    }
  }, [packageSelection]);

  const fetchPackages = async (userId, packageId = null) => {
    try {
      const packageData = await FacetoFacePackageService.getPackage(userId, packageId || '');
      if (packageData.performer) {
        setPackageData(packageData.get_package.result);
        setPackageOwner(packageData.performer);
        setIsPackageSelectionModalOpen(true);
      } else {
        dispatch(createNotification(getErrorNotificationMessage('Performer not found!')));
      }

      setPackageLoader(false);
    } catch (error) {
      dispatch(
        createNotification(getErrorNotificationMessage(parseContentServiceError(error.response))),
      );
      setPackageLoader(false);
    }
  };

  const toggleShowF2FPackagesSelectionModal = () => {
    setIsPackageSelectionModalOpen(!isPackageSelectionModalOpen);
  };

  const toggleSendMessageToPerformer = () => {
    setShowSendMessageModal(!showSendMessageModal);
  };

  return (
    <>
      <OnScreenLoader loader={packageLoader} />

      <F2FPackageSelectionModal
        isOpen={isPackageSelectionModalOpen}
        toggle={toggleShowF2FPackagesSelectionModal}
        face2facepackage_data={packageData}
        userData={packageOwner}
        toggleOpenPerformerOfflineModal={() => {
          toggleShowF2FPackagesSelectionModal();
          toggleSendMessageToPerformer();
        }}
        id={packageOwner?.id}
      />

      <F2FSendMessageToPerformer
        sessionData={newSessionData?.data}
        isOpen={showSendMessageModal}
        toggle={toggleSendMessageToPerformer}
        hideUsername={true}
        messageText={`${
          newSessionData?.data?.performer?.name 
        } is busy right now, and would love to hear from you!`}
      />
    </>
  );
};

export default F2FPackageSelection;
